import React, { useState, useEffect } from "react";
import "./Get.css";
import { API_URL } from "./API";
import { FaFilePdf, FaFileExcel, FaFilePowerpoint, FaFileArchive, FaFileAlt, FaDownload, FaSyncAlt, FaTimes, FaSave, FaCheck, FaExclamationTriangle, FaImage, FaTrash, FaUpload, FaFolder, FaFileWord, FaArrowLeft, FaHome, FaEye, FaEdit } from "react-icons/fa";

import { Document, Packer, Header, Paragraph, TextRun, HeadingLevel, convertInchesToTwip, TextWrappingType, PageNumber, SimpleField, NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingSype, } from "docx";
import { saveAs } from "file-saver";

import FormUpdate from "./FormUpdate";
import CBUpdate from "./CBUpdate";
import CablesUpdate from "./CablesUpdate";
import RelaysOneUpdate from "./RelaysOneUpdate";
import RelaysCTOneUpdate from "./RelaysCTOneUpdate";
import TransformerOneUpdate from "./TransformerOneUpdate";
import VTHomeUpdate from "./VTHomeUpdate";
import BusbarUpdate from "./BusbarUpdate";
import UpdateReport from "./UpdateReport";


const ToGetTestReportsView = ({ onCancel, project }) => {
  const [testReports, setTestReports] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [activeTab, setActiveTab] = useState('reports');
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [previewData, setPreviewData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editableReport, setEditableReport] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const [imageUploadStates, setImageUploadStates] = useState({});
  const [currentLevel, setCurrentLevel] = useState('location');
  const [currentData, setCurrentData] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);


  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedSubProject, setSelectedSubProject] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);


  const [allReports, setAllReports] = useState([]);



  const [uploadProgress, setUploadProgress] = useState({});
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadQueue, setUploadQueue] = useState([]);

  const [isUploadingFiles, setIsUploadingFiles] = useState(false);

  const [showReportScreen, setShowReportScreen] = useState(false);
  const [currentReportType, setCurrentReportType] = useState(null);
  const [showUploadedFilesScreen, setShowUploadedFilesScreen] = useState(false);

  const IMAGE_SUPPORTED_CATEGORIES = ['Transformers 1', 'Transformers 2'];

  useEffect(() => {
    if (project) {
      fetchAllReports();
    }
  }, [project]);

  useEffect(() => {
    console.log("Get component mounted/updated with project:", project);
    if (project?.project_id || project?.id) {
      fetchTestReports();
    } else {
      console.warn("No project provided to Get component");
      setTestReports([]);
    }
  }, [project?.project_id, project?.id]);

  useEffect(() => {
    if (activeTab === 'files') {
      fetchUploadedFiles();
    }
  }, [activeTab]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);


  const fetchAllReports = async () => {
    setIsLoading(true);
    setErrorMessage('');

    try {
      const projectId = project?.project_id || project?.id;

      if (!projectId) {
        throw new Error('Project ID is required');
      }

      const response = await fetch(`${API_URL}/test_report/get_test_reports?project_id=${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch reports: ${response.status}`);
      }

      const result = await response.json();
      const reports = result.data || result.reports || result || [];

      setAllReports(reports);

      if (reports.length === 0) {
        setCurrentData([]);
        return;
      }


      const subProjectsMap = new Map();
      reports.forEach(report => {
        const subProject = report.sub_project_name || 'Unknown Sub Project';
        if (!subProjectsMap.has(subProject)) {
          subProjectsMap.set(subProject, []);
        }
        subProjectsMap.get(subProject).push(report);
      });

      const subProjectData = Array.from(subProjectsMap.entries()).map(([subProject, reps]) => ({
        name: subProject,
        type: 'subProject',
        reportsCount: reps.length
      }));

      setCurrentData(subProjectData);
      setCurrentLevel('subProject');
      setBreadcrumbs([{ label: 'Sub Projects', level: 'subProject' }]);

    } catch (error) {
      console.error('Error fetching reports:', error);

      setCurrentData([]);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchTestReports = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {

      const projectId = project?.project_id || project?.id;
      console.log("=== Fetching test reports for project ===");
      console.log("Project prop:", project);
      console.log("Extracted project_id:", projectId);


      let apiUrl = `${API_URL}/test_report/get_test_reports`;
      if (projectId) {
        apiUrl += `?project_id=${projectId}`;
        console.log("Fetching with project filter:", apiUrl);
      } else {
        console.warn("No project_id found, fetching all reports");
      }

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
      }

      const result = await response.json();
      console.log('Fetched test reports:', result);

      const reportsData = result.data || result.reports || result || [];
      const reportsArray = Array.isArray(reportsData) ? reportsData : [];


      const filteredReports = projectId
        ? reportsArray.filter(report => {
          const reportProjectId = report.project_id || report.projectId;
          return String(reportProjectId) === String(projectId);
        })
        : reportsArray;

      console.log(`Found ${filteredReports.length} reports for project ${projectId}`);
      setTestReports(filteredReports);

    } catch (error) {
      console.error("Error fetching test reports:", error);
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running");
      } else {
        setErrorMessage(`Error fetching reports: ${error.message}`);
      }
      setTestReports([]);
    } finally {
      setIsLoading(false);
    }
  };



  const fetchUploadedFiles = async () => {
    setIsLoading(true);
    try {
      const projectId = project?.project_id || project?.id;
      let apiUrl = `${API_URL}/test_report/get_upload_reports`;


      if (projectId) {
        apiUrl += `?project_id=${projectId}`;
      }

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch uploaded files: ${response.status}`);
      }

      const result = await response.json();
      console.log('Fetched uploaded files:', result);

      if (result.status === 'success' && result.data) {

        const filesData = result.data;
        const filteredFiles = projectId
          ? filesData.filter(file => {
            const fileProjectId = file.project_id || file.projectId;
            return String(fileProjectId) === String(projectId);
          })
          : filesData;

        setUploadedFiles(filteredFiles);
      } else {
        setUploadedFiles([]);
      }
    } catch (error) {
      console.error("Error fetching uploaded files:", error);

      setUploadedFiles([]);
    } finally {
      setIsLoading(false);
    }
  };




  const checkDuplicateFiles = (newFiles, currentUploadedFiles) => {
    const extractBaseName = (filename) => {

      const nameWithoutExt = filename.includes('.')
        ? filename.substring(0, filename.lastIndexOf('.'))
        : filename;


      let baseName = nameWithoutExt.replace(/_\d{14}_[a-zA-Z0-9]+$/, '');

      baseName = baseName.replace(/_[a-zA-Z0-9]{8}$/, '');

      return baseName.trim().toLowerCase();
    };


    const existingBaseNames = new Set(
      currentUploadedFiles.map(file => {
        const filename = file.upload_file ? file.upload_file.split('/').pop() : '';
        return extractBaseName(filename);
      }).filter(name => name)
    );


    const existingFullNames = new Set(
      currentUploadedFiles.map(file => {
        const filename = file.upload_file ? file.upload_file.split('/').pop() : '';
        return filename.toLowerCase();
      }).filter(name => name)
    );

    const duplicates = [];
    const uniqueFiles = [];

    newFiles.forEach(file => {
      const newBaseName = extractBaseName(file.name);
      const newFullName = file.name.toLowerCase();


      if (existingBaseNames.has(newBaseName) || existingFullNames.has(newFullName)) {
        duplicates.push(file.name);
      } else {
        uniqueFiles.push(file);
      }
    });

    return { duplicates, uniqueFiles };
  };


  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) {
      return;
    }


    setIsUploadingFiles(true);
    await fetchUploadedFiles();


    await new Promise(resolve => setTimeout(resolve, 100));


    const { duplicates, uniqueFiles } = checkDuplicateFiles(files, uploadedFiles);


    event.target.value = '';


    if (duplicates.length > 0) {
      const duplicateList = duplicates.join('\n• ');
      alert(`⚠️ The following file(s) already exist:\n\n• ${duplicateList}\n\nThese files will not be uploaded. Please rename them or delete the existing files first.`);


      if (uniqueFiles.length === 0) {
        setIsUploadingFiles(false);
        return;
      }
    }

    const projectId = project?.project_id || project?.id;
    let successCount = 0;
    let failCount = 0;
    const failedFiles = [];

    for (let i = 0; i < uniqueFiles.length; i++) {
      const file = uniqueFiles[i];

      try {
        const base64File = await convertFileToBase64(file);

        const getMimeType = (filename) => {
          const ext = filename.split('.').pop().toLowerCase();
          const mimeTypes = {
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'pdf': 'application/pdf',
            'txt': 'text/plain',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'zip': 'application/zip',
            'rar': 'application/x-rar-compressed'
          };
          return mimeTypes[ext] || 'application/octet-stream';
        };

        const fileType = getMimeType(file.name) || file.type;

        const uploadPayload = {
          base64_file: base64File,
          filename: file.name,
          file_type: fileType,
          file_size: file.size,
          project_id: projectId ? parseInt(projectId) : null
        };

        const apiUrl = `${API_URL}/test_report/create_upload_reports`;

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(uploadPayload),
          mode: 'cors',
          credentials: 'same-origin',
        });

        if (response.status === 409) {
          failCount++;
          failedFiles.push(`${file.name} (already exists)`);
          continue;
        }

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          failCount++;
          failedFiles.push(`${file.name} (${errorData.message || 'upload failed'})`);
          continue;
        }

        await response.json();
        successCount++;

      } catch (uploadError) {
        failCount++;
        failedFiles.push(`${file.name} (${uploadError.message})`);
      }


      await new Promise(resolve => setTimeout(resolve, 300));
    }

    setIsUploadingFiles(false);


    let finalMessage = '';

    if (successCount > 0 && failCount === 0) {
      finalMessage = `✅ Successfully uploaded ${successCount} file(s)!`;
    } else if (successCount > 0 && failCount > 0) {
      finalMessage = `⚠️ Upload Results:\n\n✅ Successfully uploaded: ${successCount} file(s)\n❌ Failed: ${failCount} file(s)\n\nFailed files:\n• ${failedFiles.join('\n• ')}`;
    } else if (failCount > 0) {
      finalMessage = `❌ Failed to upload ${failCount} file(s):\n\n• ${failedFiles.join('\n• ')}`;
    }

    if (duplicates.length > 0 && finalMessage) {
      finalMessage += `\n\n📝 Note: ${duplicates.length} duplicate file(s) were skipped.`;
    } else if (duplicates.length > 0 && !finalMessage) {
      finalMessage = `📝 ${duplicates.length} duplicate file(s) were skipped. No new files uploaded.`;
    }

    if (finalMessage) {
      alert(finalMessage);
    }


    await fetchUploadedFiles();
  };

  const UploadModal = React.memo(({ uploadQueue, onClose, onCancelUpload }) => (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '400px',
      maxHeight: '500px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 9999,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      pointerEvents: 'auto'
    }}>
      <div style={{
        padding: '16px',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
          Uploading {uploadQueue.filter(f => f.status === 'uploading' || f.status === 'pending').length} of {uploadQueue.length} files
        </h4>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666',
            padding: '0',
            width: '24px',
            height: '24px'
          }}
        >
          ×
        </button>
      </div>

      <div style={{
        overflowY: 'auto',
        maxHeight: '400px',
        padding: '8px'
      }}>
        {uploadQueue.map((file) => (
          <div key={file.id} style={{
            padding: '12px',
            marginBottom: '8px',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            backgroundColor: file.status === 'completed' ? '#f0f9ff' :
              file.status === 'failed' ? '#fff5f5' :
                file.status === 'cancelled' ? '#f5f5f5' : 'white'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  marginBottom: '4px'
                }}>
                  {file.name}
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {formatFileSize(file.size)}
                </div>
              </div>

              <div style={{ marginLeft: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {file.status === 'completed' && (
                  <FaCheck style={{ color: '#28a745', fontSize: '16px' }} />
                )}
                {file.status === 'failed' && (
                  <FaExclamationTriangle style={{ color: '#dc3545', fontSize: '16px' }} />
                )}
                {file.status === 'cancelled' && (
                  <FaTimes style={{ color: '#6c757d', fontSize: '16px' }} />
                )}
                {file.status === 'uploading' && (
                  <div className="GET-21" style={{ width: '16px', height: '16px' }}></div>
                )}
                {file.status === 'pending' && (
                  <button
                    onClick={() => onCancelUpload(file.id)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#666',
                      padding: '4px'
                    }}
                    title="Cancel upload"
                  >
                    <FaTimes />
                  </button>
                )}
              </div>
            </div>

            {(file.status === 'uploading' || file.status === 'pending') && (
              <div style={{
                width: '100%',
                height: '4px',
                backgroundColor: '#e0e0e0',
                borderRadius: '2px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${file.progress}%`,
                  height: '100%',
                  backgroundColor: '#007bff',
                  transition: 'width 0.3s ease'
                }} />
              </div>
            )}

            {file.status === 'completed' && (
              <div style={{ fontSize: '12px', color: '#28a745', marginTop: '4px' }}>
                ✓ Upload complete
              </div>
            )}

            {file.status === 'failed' && (
              <div style={{ fontSize: '12px', color: '#dc3545', marginTop: '4px' }}>
                ✗ {file.error || 'Upload failed'}
              </div>
            )}

            {file.status === 'cancelled' && (
              <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                Cancelled
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  ));

  const handleFileDelete = async (uploadId) => {


    try {
      const response = await fetch(`${API_URL}/test_report/delete_upload_reports`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          upload_id: uploadId
        }),
        mode: 'cors',
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to delete file: ${response.status}`);
      }

      const result = await response.json();
      setSuccessMessage(result.message || 'File deleted successfully');


      await fetchUploadedFiles();

    } catch (error) {
      console.error("Error deleting file:", error);
      setErrorMessage(`Error deleting file: ${error.message}`);
    }
  };





  const handleFileDownload = async (file) => {
    try {
      setSuccessMessage('Downloading file...');

      const filename = file.upload_file ? file.upload_file.split('/').pop() : 'download';


      const fileExtension = filename.split('.').pop().toLowerCase();


      const response = await fetch(`${API_URL}/test_report/download_upload_report/${filename}`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Accept': '*/*',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }


      const contentType = response.headers.get('content-type') || 'application/octet-stream';
      const blob = await response.blob();


      const getMimeType = (ext) => {
        const mimeTypes = {
          'pdf': 'application/pdf',
          'doc': 'application/msword',
          'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'xls': 'application/vnd.ms-excel',
          'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'ppt': 'application/vnd.ms-powerpoint',
          'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'txt': 'text/plain',
          'jpg': 'image/jpeg',
          'jpeg': 'image/jpeg',
          'png': 'image/png',
          'gif': 'image/gif',
          'zip': 'application/zip',
          'rar': 'application/x-rar-compressed',
          '7z': 'application/x-7z-compressed',
          'tar': 'application/x-tar',
          'gz': 'application/gzip'
        };
        return mimeTypes[ext] || 'application/octet-stream';
      };

      const correctMimeType = contentType !== 'application/octet-stream'
        ? contentType
        : getMimeType(fileExtension);


      const typedBlob = new Blob([blob], { type: correctMimeType });


      const url = URL.createObjectURL(typedBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();


      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 100);

      setSuccessMessage(`File "${filename}" downloaded successfully!`);

    } catch (error) {
      console.error("Error downloading file:", error);
      setErrorMessage(`Error downloading file: ${error.message}`);
    }
  };



  const handleFileView = async (file) => {
    try {
      if (!file.upload_file) {
        throw new Error('File URL not found');
      }

      const filePathParts = file.upload_file.split('/');
      const filename = filePathParts[filePathParts.length - 1];
      const fileUrl = `${API_URL}/test_report/view_upload_report/${filename}`;
      const fileExtension = filename.split('.').pop().toLowerCase();

      console.log('Attempting to view file:', filename);
      console.log('File URL:', fileUrl);
      console.log('File extension:', fileExtension);


      if (['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(fileExtension)) {
        console.log('Opening image/PDF in new tab');
        window.open(fileUrl, '_blank', 'noopener,noreferrer');
        setSuccessMessage('Opening file in new tab...');
        return;
      }


      if (['txt', 'html', 'htm', 'css', 'js', 'json', 'xml'].includes(fileExtension)) {
        console.log('Opening text file in new tab');
        window.open(fileUrl, '_blank', 'noopener,noreferrer');
        setSuccessMessage('Opening text file...');
        return;
      }


      if (['doc', 'docx'].includes(fileExtension)) {
        console.log('Downloading Word document');
        setSuccessMessage('Downloading Word document... Please wait.');

        try {

          const response = await fetch(fileUrl, {
            method: 'GET',
            mode: 'cors',
            credentials: 'same-origin',
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);


          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();


          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
          }, 100);

          setSuccessMessage(`Word document "${filename}" downloaded successfully! Open it with Microsoft Word.`);

        } catch (fetchError) {
          console.error('Fetch method failed, trying direct link:', fetchError);


          const a = document.createElement('a');
          a.href = fileUrl;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          setSuccessMessage(`Downloading "${filename}"... Open with Microsoft Word to view.`);
        }
        return;
      }


      if (['xls', 'xlsx', 'csv'].includes(fileExtension)) {
        console.log('Downloading Excel file');
        setSuccessMessage('Downloading Excel file... Please wait.');

        try {
          const response = await fetch(fileUrl, {
            method: 'GET',
            mode: 'cors',
            credentials: 'same-origin',
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();

          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
          }, 100);

          setSuccessMessage(`Excel file "${filename}" downloaded successfully! Open it with Microsoft Excel.`);

        } catch (fetchError) {
          console.error('Fetch method failed, trying direct link:', fetchError);

          const a = document.createElement('a');
          a.href = fileUrl;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          setSuccessMessage(`Downloading "${filename}"... Open with Microsoft Excel to view.`);
        }
        return;
      }


      if (['ppt', 'pptx'].includes(fileExtension)) {
        console.log('Downloading PowerPoint file');
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setSuccessMessage(`Downloading "${filename}"... Open with PowerPoint to view.`);
        return;
      }


      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(fileExtension)) {
        console.log('Downloading archive file');
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setSuccessMessage(`Downloading archive "${filename}"...`);
        return;
      }


      console.log('Unknown file type, attempting to open');
      const newWindow = window.open(fileUrl, '_blank', 'noopener,noreferrer');

      if (newWindow) {
        setSuccessMessage('Opening file in new tab...');
      } else {
        console.log('Popup blocked, downloading instead');
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setSuccessMessage(`Downloading "${filename}"...`);
      }

    } catch (error) {
      console.error("Error viewing file:", error);
      setErrorMessage(`Error opening file: ${error.message}`);
    }
  };



  const getLocation = (report) => {

    return report.location || 'Unknown Location';
  };

  const filterReports = (filters) => {
    return allReports.filter(report => {
      if (filters.location && getLocation(report) !== filters.location) return false;
      if (filters.subProject && report.sub_project_name !== filters.subProject) return false;
      if (filters.category && report.category_name !== filters.category) return false;
      if (filters.subCategory && report.subcategory_name !== filters.subCategory) return false;
      if (filters.equipment && report.equipment_name !== filters.equipment) return false;
      return true;
    });
  };

  const handleCardClick = (item) => {
    switch (currentLevel) {
      case 'subProject':
        setSelectedSubProject(item.name);

        const reportsForSubProject = filterReports({ subProject: item.name });
        const equipmentTypes = [...new Set(reportsForSubProject.map(r => r.equipment_name?.toLowerCase()).filter(Boolean))];

        const hasCablesOrTransformers = equipmentTypes.some(eq =>
          eq.includes('cable') || eq.includes('transformer')
        );


        const hasBusbar = reportsForSubProject.some(r =>
          r.subcategory_name?.toLowerCase().includes('bus bar') ||
          r.subcategory_name?.toLowerCase() === 'busbar' ||
          r.equipment_name?.toLowerCase().includes('busbar')
        );

        if (hasCablesOrTransformers) {
          showEquipmentsForCablesTransformers(item.name);
        } else if (hasBusbar) {

          showCategories(item.name);
        } else {
          showCategories(item.name);
        }
        break;

      case 'category':
        setSelectedCategory(item.name);


        const isBusbar = selectedSubProject && allReports.some(r =>
          r.sub_project_name === selectedSubProject &&
          r.category_name === item.name &&
          (r.subcategory_name?.toLowerCase().includes('bus bar') ||
            r.subcategory_name?.toLowerCase() === 'busbar' ||
            r.equipment_name?.toLowerCase().includes('busbar'))
        );

        if (isBusbar) {

          showBusbarFolder(selectedSubProject, item.name);
        } else {
          showSubCategories(selectedSubProject, item.name);
        }
        break;

      case 'busbarFolder':

        showBusbarReports(selectedSubProject, selectedCategory);
        break;

      case 'subCategory':
        setSelectedSubCategory(item.name);
        showEquipments(selectedSubProject, selectedCategory, item.name);
        break;

      case 'equipment':
        setSelectedEquipment(item.name);
        showReports(selectedSubProject, selectedCategory, selectedSubCategory, item.name);
        break;

      case 'reports':
        handlePreview(item.fullReport);
        break;
    }
  };


  const showBusbarFolder = (subProject, category) => {

    const data = [{
      name: 'Busbar',
      type: 'busbarFolder',
      reportsCount: allReports.filter(r =>
        r.sub_project_name === subProject &&
        r.category_name === category &&
        (r.subcategory_name?.toLowerCase().includes('bus bar') ||
          r.subcategory_name?.toLowerCase() === 'busbar' ||
          r.equipment_name?.toLowerCase().includes('busbar'))
      ).length
    }];

    setCurrentData(data);
    setCurrentLevel('busbarFolder');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' },
      { label: category, level: 'busbarFolder' }
    ]);
  };

  const showBusbarReports = (subProject, category) => {
    const filtered = filterReports({
      subProject,
      category
    }).filter(r =>
      r.subcategory_name?.toLowerCase().includes('bus bar') ||
      r.subcategory_name?.toLowerCase() === 'busbar' ||
      r.equipment_name?.toLowerCase().includes('busbar')
    );

    const data = filtered.map(report => ({
      id: report.report_id,
      name: report.equipment_name || 'Busbar Report',
      type: 'report',
      test_date: report.test_date,
      fullReport: report
    }));

    setCurrentData(data);
    setCurrentLevel('reports');

    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' },
      { label: category, level: 'busbarFolder' },
      { label: 'Busbar', level: 'reports' }
    ]);
  };


  const showSubProjects = () => {
    const unique = [...new Set(allReports.map(r => r.sub_project_name).filter(Boolean))];

    const data = unique.map(subProject => ({
      name: subProject,
      type: 'subProject',
      reportsCount: allReports.filter(r => r.sub_project_name === subProject).length
    }));

    setCurrentData(data);
    setCurrentLevel('subProject');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' }
    ]);
  };


  const showEquipmentsForCablesTransformers = (subProject) => {
    const filtered = filterReports({ subProject });
    const unique = [...new Set(filtered.map(r => r.equipment_name).filter(Boolean))];

    const data = unique.map(equipment => ({
      name: equipment,
      type: 'equipment',
      reportsCount: filtered.filter(r => r.equipment_name === equipment).length
    }));

    setCurrentData(data);
    setCurrentLevel('equipment');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'equipment' }
    ]);
  };


  const showCategoriesForBusbar = (subProject) => {
    const filtered = filterReports({ subProject });
    const unique = [...new Set(filtered.map(r => r.category_name).filter(Boolean))];

    const data = unique.map(category => ({
      name: category,
      type: 'category',
      reportsCount: filtered.filter(r => r.category_name === category).length
    }));

    setCurrentData(data);
    setCurrentLevel('category');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' }
    ]);
  };

  const showEquipmentsForBusbar = (subProject, category) => {
    const filtered = filterReports({ subProject, category });
    const unique = [...new Set(filtered.map(r => r.equipment_name).filter(Boolean))];

    const data = unique.map(equipment => ({
      name: equipment,
      type: 'equipment',
      reportsCount: filtered.filter(r => r.equipment_name === equipment).length
    }));

    setCurrentData(data);
    setCurrentLevel('equipment');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' },
      { label: category, level: 'equipment' }
    ]);
  };


  const showCategories = (subProject) => {
    const filtered = filterReports({ subProject });
    const unique = [...new Set(filtered.map(r => r.category_name).filter(Boolean))];

    const data = unique.map(category => ({
      name: category,
      type: 'category',
      reportsCount: filtered.filter(r => r.category_name === category).length
    }));

    setCurrentData(data);
    setCurrentLevel('category');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' }
    ]);
  };

  const showSubCategories = (subProject, category) => {
    const filtered = filterReports({ subProject, category });
    const unique = [...new Set(filtered.map(r => r.subcategory_name).filter(Boolean))];

    const data = unique.map(subCategory => ({
      name: subCategory,
      type: 'subCategory',
      reportsCount: filtered.filter(r => r.subcategory_name === subCategory).length
    }));

    setCurrentData(data);
    setCurrentLevel('subCategory');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' },
      { label: category, level: 'subCategory' }
    ]);
  };

  const showEquipments = (subProject, category, subCategory) => {
    const filtered = filterReports({ subProject, category, subCategory });
    const unique = [...new Set(filtered.map(r => r.equipment_name).filter(Boolean))];

    const data = unique.map(equipment => ({
      name: equipment,
      type: 'equipment',
      reportsCount: filtered.filter(r => r.equipment_name === equipment).length
    }));

    setCurrentData(data);
    setCurrentLevel('equipment');
    setBreadcrumbs([
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: 'category' },
      { label: category, level: 'subCategory' },
      { label: subCategory, level: 'equipment' }
    ]);
  };

  const showReports = (subProject, category, subCategory, equipment) => {

    const filterObj = { subProject, equipment };


    if (category) filterObj.category = category;
    if (subCategory) filterObj.subCategory = subCategory;

    const filtered = filterReports(filterObj);

    const data = filtered.map(report => ({
      id: report.report_id,
      name: `${report.equipment_name || 'Report'}`,
      type: 'report',
      test_date: report.test_date,
      fullReport: report
    }));

    setCurrentData(data);
    setCurrentLevel('reports');


    const breadcrumbsList = [
      { label: 'Sub Projects', level: 'subProject' },
      { label: subProject, level: category ? 'category' : 'equipment' }
    ];

    if (category) {
      breadcrumbsList.push({ label: category, level: subCategory ? 'subCategory' : 'equipment' });
    }

    if (subCategory) {
      breadcrumbsList.push({ label: subCategory, level: 'equipment' });
    }

    breadcrumbsList.push({ label: equipment, level: 'reports' });

    setBreadcrumbs(breadcrumbsList);
  };


  const handleBreadcrumbClick = (index) => {
    const clickedBreadcrumb = breadcrumbs[index];

    switch (clickedBreadcrumb.level) {
      case 'subProject':
        showSubProjects();
        setSelectedSubProject(null);
        setSelectedCategory(null);
        setSelectedSubCategory(null);
        setSelectedEquipment(null);
        break;

      case 'category':
        if (index === 1) {
          const subProject = breadcrumbs[1].label;
          const reportsForSubProject = filterReports({ subProject });

          const hasCablesOrTransformers = reportsForSubProject.some(r => {
            const eq = r.equipment_name?.toLowerCase();
            return eq && (eq.includes('cable') || eq.includes('transformer'));
          });

          const hasBusbar = reportsForSubProject.some(r =>
            r.subcategory_name?.toLowerCase().includes('bus bar') ||
            r.subcategory_name?.toLowerCase() === 'busbar' ||
            r.equipment_name?.toLowerCase().includes('busbar')
          );

          if (hasCablesOrTransformers) {
            showEquipmentsForCablesTransformers(subProject);
          } else if (hasBusbar) {
            showCategories(subProject);
          } else {
            showCategories(subProject);
          }
        } else {
          showCategories(selectedSubProject);
        }
        setSelectedCategory(null);
        setSelectedSubCategory(null);
        setSelectedEquipment(null);
        break;

      case 'busbarFolder':

        showBusbarFolder(selectedSubProject, selectedCategory);
        break;

      case 'subCategory':
        showSubCategories(selectedSubProject, selectedCategory);
        setSelectedSubCategory(null);
        setSelectedEquipment(null);
        break;

      case 'equipment':
        if (breadcrumbs.length === 3 && breadcrumbs[1].level === 'equipment') {
          showEquipmentsForCablesTransformers(selectedSubProject);
        } else if (breadcrumbs.length === 4 && !selectedSubCategory) {
          showEquipmentsForBusbar(selectedSubProject, selectedCategory);
        } else {
          showEquipments(selectedSubProject, selectedCategory, selectedSubCategory);
        }
        setSelectedEquipment(null);
        break;
    }
  };

  const handleBack = () => {
    if (breadcrumbs.length > 1) {
      handleBreadcrumbClick(breadcrumbs.length - 2);
    }
  };

  const handleHome = () => {
    showSubProjects();
    setSelectedSubProject(null);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setSelectedEquipment(null);
  };





  const handlePreview = (report) => {
    console.log('Opening report for preview:', report);
    setPreviewData(report);
    setEditableReport({ ...report });
    setIsEditing(false);
    setErrorMessage("");
    setSuccessMessage("");
    setValidationErrors({});
    setImageLoadingStates({});
    setImageUploadStates({});
  };



  const handleEdit = () => {
    console.log('Entering edit mode for report:', previewData);

    const categoryName = previewData?.category_name?.toLowerCase() || '';
    const subcategoryName = previewData?.subcategory_name?.toLowerCase() || '';
    const equipmentName = previewData?.equipment_name?.toLowerCase() || '';

    let reportType = null;


    if (subcategoryName.includes('bus bar') || subcategoryName === 'busbar' ||
      categoryName.includes('busbar') || categoryName.includes('bus bar')) {
      reportType = 'BUSBAR';
    } else if (categoryName.includes('cable') || subcategoryName.includes('cable')) {
      reportType = 'CABLES';
    } else if (categoryName.includes('transformer')) {
      reportType = 'TRANSFORMERS';
    } else if (equipmentName.includes('relaysct') || equipmentName === 'relaysct' || equipmentName.includes('relays ct')) {
      reportType = 'RELAYSCT';
    } else if (equipmentName.includes('cb') || equipmentName === 'cb' || categoryName.includes('circuit breaker') || subcategoryName.includes('circuit breaker')) {
      reportType = 'CB';
    } else if (equipmentName.includes('relay') || equipmentName === 'relays' || categoryName.includes('relay') || subcategoryName.includes('relay')) {
      reportType = 'RELAYS';
    } else if (equipmentName.includes('ct') || equipmentName === 'ct' || categoryName.includes('current transformer') || subcategoryName.includes('ct')) {
      reportType = 'CT';
    } else if (equipmentName.includes('vt') || equipmentName === 'vt' || categoryName.includes('voltage transformer') || subcategoryName.includes('vt')) {
      reportType = 'VT';
    }

    console.log('Detected report type:', reportType);
    console.log('Category:', categoryName, 'Subcategory:', subcategoryName, 'Equipment:', equipmentName);

    const updatePayload = {
      ...previewData,
      project_id: project?.project_id || project?.id || previewData.project_id,
      report_id: previewData.id || previewData._id || previewData.report_id
    };

    console.log('Storing update payload:', updatePayload);

    // Clear all VT-related localStorage to ensure fresh data load
    const vtStorageKeys = [
      'vtFormDataUpdate',
      'vt_insulation_data_update',
      'vt_winding_resistance_data_update',
      'vt_polarity_check_data_update',
      'vtRatioTestDataUpdate',
      'vt_checklist_data',
      'vt_list_autosave'
    ];

    console.log('Clearing stale VT localStorage keys...');
    vtStorageKeys.forEach(key => {
      localStorage.removeItem(key);
    });
    console.log('✓ Cleared stale localStorage');

    localStorage.setItem('updateReportData', JSON.stringify(updatePayload));

    const storedData = localStorage.getItem('updateReportData');
    if (storedData) {
      const parsed = JSON.parse(storedData);
      console.log("✓ Verified stored project_id:", parsed.project_id);
      console.log("✓ Verified stored report_id:", parsed.report_id);
      console.log("✓ Stored test_data keys:", Object.keys(parsed.test_data || {}));
    }

    if (reportType) {
      setCurrentReportType(reportType);
      setShowReportScreen(true);
    } else {
      console.warn('Could not detect report type, falling back to inline editing');
      console.log('Available data for detection:', { categoryName, subcategoryName, equipmentName, previewData });

      setIsEditing(true);
      setErrorMessage("");
      setSuccessMessage("");
      setValidationErrors({});

      if (!editableReport) {
        setEditableReport({ ...previewData });
      }
    }
  };

  const handleCancel = () => {
    if (isEditing) {
      console.log('Canceling edit mode, reverting changes');
      setEditableReport({ ...previewData });
      setIsEditing(false);
      setValidationErrors({});
      setImageUploadStates({});
    } else {
      console.log('Closing preview modal');
      setPreviewData(null);
      setEditableReport(null);
    }
    setErrorMessage("");
    setSuccessMessage("");
  };

  const handleFieldChange = (field, value) => {
    console.log(`Updating field ${field} with value:`, value);

    setEditableReport(prev => {
      const updated = {
        ...prev,
        [field]: value
      };

      if (updated.test_data && updated.test_data.circuitBreakerData) {
        const circuitBreakerData = { ...updated.test_data.circuitBreakerData };

        switch (field) {
          case 'location':
            circuitBreakerData.location = value;
            break;
          case 'test_date':
            circuitBreakerData.date = value;
            break;
          case 'sub_project_name':
            circuitBreakerData.project = value;
            break;
        }

        updated.test_data = {
          ...updated.test_data,
          circuitBreakerData
        };
      }

      return updated;
    });

    if (validationErrors[field]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };


  const handleImageUpload = async (imageField, file) => {
    if (!file) return;

    setImageUploadStates(prev => ({
      ...prev,
      [imageField]: { uploading: true, error: null }
    }));

    try {

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;


        setEditableReport(prev => {
          const updated = { ...prev };
          const keys = imageField.split('.');
          let current = updated.test_data;

          for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
              current[keys[i]] = {};
            }
            current = current[keys[i]];
          }

          const finalKey = keys[keys.length - 1];
          current[finalKey] = base64Data;
          return updated;
        });

        setImageUploadStates(prev => ({
          ...prev,
          [imageField]: { uploading: false, error: null, uploaded: true }
        }));
      };

      reader.onerror = () => {
        setImageUploadStates(prev => ({
          ...prev,
          [imageField]: { uploading: false, error: 'Failed to read file', uploaded: false }
        }));
      };

      reader.readAsDataURL(file);

    } catch (error) {
      console.error('Error uploading image:', error);
      setImageUploadStates(prev => ({
        ...prev,
        [imageField]: { uploading: false, error: error.message, uploaded: false }
      }));
    }
  };


  const handleImageRemove = (imageField) => {
    setEditableReport(prev => {
      const updated = { ...prev };
      const keys = imageField.split('.');
      let current = updated.test_data;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {};
        }
        current = current[keys[i]];
      }

      const finalKey = keys[keys.length - 1];
      current[finalKey] = null;

      return updated;
    });

    setImageUploadStates(prev => ({
      ...prev,
      [imageField]: { uploading: false, error: null, uploaded: false }
    }));
  };

  const syncAllRelatedFields = (report) => {
    const synced = { ...report };

    if (synced.test_data && synced.test_data.circuitBreakerData) {
      const circuitBreakerData = { ...synced.test_data.circuitBreakerData };

      if (synced.location) circuitBreakerData.location = synced.location;
      if (synced.test_date) circuitBreakerData.date = synced.test_date;
      if (synced.sub_project_name) circuitBreakerData.project = synced.sub_project_name;
      if (synced.equipment_name) circuitBreakerData.description = synced.equipment_name;

      synced.test_data.circuitBreakerData = circuitBreakerData;
    }

    return synced;
  };

  const redirectToHome = () => {

    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";

  };



  const handleSaveChanges = async () => {
    console.log('=== STARTING SAVE PROCESS ===');
    console.log('Editable Report Data:', editableReport);

    setErrorMessage("");
    setSuccessMessage("");
    setIsSaving(true);

    try {
      console.log('Step 1: Validating report data...');
      const errors = validateReport(editableReport);

      if (Object.keys(errors).length > 0) {
        console.log('Validation failed:', errors);
        setValidationErrors(errors);
        setErrorMessage("Please fix the validation errors before saving.");
        setIsSaving(false);
        return;
      }

      console.log('Validation passed');
      setValidationErrors({});

      console.log('Step 2: Getting report ID...');
      const reportId = editableReport.id || editableReport._id || editableReport.report_id;

      if (!reportId) {
        console.log('No report ID found');
        throw new Error('Report ID is missing. Cannot update report without ID.');
      }

      console.log('Report ID found:', reportId);

      console.log('Step 3: Syncing all related fields...');
      const syncedReport = syncAllRelatedFields(editableReport);
      console.log('Synced report data:', syncedReport);

      console.log('Step 4: Preparing PDF data...');
      let pdfBase64 = null;

      console.log('Step 5: Preparing update payload...');
      const updatePayload = {
        report_id: parseInt(reportId),
        equipment_id: syncedReport.equipment_id ? parseInt(syncedReport.equipment_id) : null,
        equipment_name: (syncedReport.equipment_name || '').trim(),
        test_date: syncedReport.test_date || new Date().toISOString().split('T')[0],
        category_id: syncedReport.category_id ? parseInt(syncedReport.category_id) : null,
        category_name: (syncedReport.category_name || '').trim(),
        subcategory_id: syncedReport.subcategory_id ? parseInt(syncedReport.subcategory_id) : null,
        subcategory_name: (syncedReport.subcategory_name || '').trim(),
        sub_project_name: (syncedReport.sub_project_name || '').trim(),
        sub_project_id: syncedReport.sub_project_id ?
          parseInt(syncedReport.sub_project_id) :
          (syncedReport.subproject_id ? parseInt(syncedReport.subproject_id) :
            (syncedReport.subProjectId ? parseInt(syncedReport.subProjectId) : 1)),
        project_id: syncedReport.project_id ?
          parseInt(syncedReport.project_id) :
          (typeof syncedReport.project_id === 'string' ?
            parseInt(syncedReport.project_id.replace(/\D/g, '')) || 1 : 1),
        location: (syncedReport.location || '').trim(),
        test_data: syncedReport.test_data || {},
        filename: `Test_Report_${reportId}_Updated_${Date.now()}.pdf`,
        file_type: "application/pdf",
        report_pdf: pdfBase64
      };

      console.log('Final update payload:', updatePayload);

      console.log('Step 6: Sending update request to backend...');
      console.log('API URL:', `${API_URL}/test_report/update_test_report`);

      const response = await fetch(`${API_URL}/test_report/update_test_report`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(updatePayload),
        mode: 'cors',
        credentials: 'same-origin',
      });

      console.log('Backend response received. Status:', response.status);

      if (!response.ok) {
        console.log('Backend returned error status:', response.status);

        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;

        try {
          const errorData = await response.json();
          console.log('Error response data:', errorData);

          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.detail) {
            errorMessage = errorData.detail;
          }

          if (errorData.error_type) {
            errorMessage += ` (${errorData.error_type})`;
          }

        } catch (parseError) {
          console.log('Could not parse error as JSON, trying as text...');
          try {
            const errorText = await response.text();
            console.log('Error response text:', errorText);
            errorMessage = errorText || errorMessage;
          } catch (textError) {
            console.log('Could not parse error response at all');
          }
        }

        throw new Error(errorMessage);
      }

      console.log('Backend returned success status');

      let result = {
        success: false,
        message: 'Unknown response',
        data: null
      };

      try {
        const contentType = response.headers.get('content-type');
        console.log('Response content type:', contentType);

        if (contentType && contentType.includes('application/json')) {
          const responseData = await response.json();
          console.log('Success response data:', responseData);

          result = {
            success: responseData.status === 'success',
            message: responseData.message || 'Report updated successfully',
            data: responseData.data || responseData
          };
        } else {
          const responseText = await response.text();
          console.log('Non-JSON response text:', responseText);
          result = {
            success: true,
            message: responseText || 'Report updated successfully',
            data: updatePayload
          };
        }
      } catch (parseError) {
        console.log('Could not parse success response, treating as success anyway');
        result = {
          success: true,
          message: 'Report updated successfully',
          data: updatePayload
        };
      }

      console.log('Step 7: Updating local state...');

      const updatedReportData = {
        ...syncedReport,
        id: reportId,
        report_id: reportId,
        _id: reportId,
        ...(result.data && typeof result.data === 'object' ? result.data : {})
      };

      const updatedReports = testReports.map(report => {
        const currentId = report.id || report._id || report.report_id;
        if (currentId === reportId) {
          console.log('Updating report in list:', currentId);
          return updatedReportData;
        }
        return report;
      });

      setTestReports(updatedReports);
      setPreviewData(updatedReportData);
      setIsEditing(false);
      setValidationErrors({});
      setImageUploadStates({});

      const successMsg = result.message || 'Report updated successfully! Changes have been saved.';
      setSuccessMessage(successMsg);

      alert("Test report updated successfully!");

      console.log('=== SAVE PROCESS COMPLETED SUCCESSFULLY ===');

    } catch (error) {
      console.log('Save process failed:', error);
      console.error('Full error object:', error);

      let errorMsg = 'Unknown error occurred';

      if (error && error.message) {
        errorMsg = error.message;
      } else if (typeof error === 'string') {
        errorMsg = error;
      } else {
        errorMsg = 'An unexpected error occurred while saving the report';
      }

      if (errorMsg.includes("Failed to fetch") || error?.name === 'TypeError') {
        errorMsg = "Cannot connect to server. Please check if the backend is running on " + API_URL;
        alert("Cannot connect to server. Please check if the backend is running.");
      } else {
        alert(`Error updating report: ${errorMsg}`);
      }

      setErrorMessage(errorMsg);
      console.log('=== SAVE PROCESS FAILED ===');

    } finally {
      setIsSaving(false);
    }
  };

  const validateReport = (report) => {
    const errors = {};

    if (!report.equipment_name?.trim()) {
      errors.equipment_name = 'Equipment name is required';
    }

    if (!report.test_date) {
      errors.test_date = 'Test date is required';
    }

    if (!report.category_name?.trim()) {
      errors.category_name = 'Category is required';
    }

    if (!report.location?.trim()) {
      errors.location = 'Location is required';
    }

    return errors;
  };


  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const getCleanFilename = (filePath) => {
    if (!filePath) return 'Unknown File';

    const filename = filePath.split('/').pop();


    return filename;
  };


  const handleDownloadReport = async (report) => {
    try {
      setSuccessMessage('Generating comprehensive Word report...');

      const filename = await generateWordReport(report);

      setSuccessMessage(`Word report "${filename}" downloaded successfully!`);

    } catch (error) {
      console.error('Error downloading report:', error);
      setErrorMessage('Error generating Word report: ' + error.message);
    }
  };

  const handleDownloadAll = async () => {
    if (filteredReports.length === 0) {
      setErrorMessage('No reports available to download.');
      return;
    }

    setIsDownloadingAll(true);
    setSuccessMessage('Generating Word reports...');

    try {
      let downloadCount = 0;
      const totalReports = filteredReports.length;

      for (let i = 0; i < filteredReports.length; i++) {
        const report = filteredReports[i];

        try {
          await generateWordReport(report);
          downloadCount++;


          if (i < filteredReports.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        } catch (error) {
          console.error(`Error generating Word document for report ${report.id}:`, error);
        }
      }

      setSuccessMessage(`Successfully downloaded ${downloadCount} of ${totalReports} reports as Word files!`);

    } catch (error) {
      console.error('Error downloading all reports:', error);
      setErrorMessage('Error downloading reports: ' + error.message);
    } finally {
      setIsDownloadingAll(false);
    }
  };



  const formatFileSize = (bytes) => {
    if (!bytes) return 'N/A';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  const getFileTypeLabel = (filePath) => {
    if (!filePath) return '📎 Unknown';

    const ext = filePath.split('.').pop().toLowerCase();

    const fileTypes = {
      'pdf': ' PDF Document',
      'doc': ' Word Document',
      'docx': ' Word Document',
      'xls': 'Excel File',
      'xlsx': ' Excel File',
      'ppt': ' PowerPoint',
      'pptx': ' PowerPoint',
      'txt': ' Text File',
      'jpg': ' Image File',
      'jpeg': ' Image File',
      'png': ' Image File',
      'gif': ' Image File',
      'zip': ' Archive File',
      'rar': ' Archive File'
    };

    return fileTypes[ext] || `📎 ${ext.toUpperCase()} File`;
  };



  const getFileIcon = (filePath) => {
    if (!filePath) return <FaUpload style={{ marginRight: '8px', color: '#007bff', flexShrink: 0 }} />;

    const ext = filePath.split('.').pop().toLowerCase();

    const iconStyle = { marginRight: '8px', flexShrink: 0, fontSize: '24px' };

    switch (ext) {
      case 'doc':
      case 'docx':
        return <FaFileWord style={{ ...iconStyle, color: '#2b579a' }} />;
      case 'pdf':
        return <FaFilePdf style={{ ...iconStyle, color: '#dc3545' }} />;
      case 'xls':
      case 'xlsx':
        return <FaFileExcel style={{ ...iconStyle, color: '#217346' }} />;
      case 'ppt':
      case 'pptx':
        return <FaFilePowerpoint style={{ ...iconStyle, color: '#d24726' }} />;
      case 'zip':
      case 'rar':
      case '7z':
        return <FaFileArchive style={{ ...iconStyle, color: '#f59e0b' }} />;
      case 'txt':
        return <FaFileAlt style={{ ...iconStyle, color: '#6c757d' }} />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <FaImage style={{ ...iconStyle, color: '#17a2b8' }} />;
      default:
        return <FaUpload style={{ ...iconStyle, color: '#007bff' }} />;
    }
  };



  const generateWordReport = async (report) => {
    try {

      if (!Document || !Packer || !Paragraph || !TextRun || !Table || !TableRow || !TableCell) {
        throw new Error('docx library components are not properly imported. Please ensure you have installed docx package: npm install docx');
      }


      const convertInchesToTwip = (inches) => {
        return Math.round(inches * 1440);
      };


      const fetchImageAsBase64 = async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Error fetching image:', error);
          return null;
        }
      };


      const createLightWatermark = async (base64Image) => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const img = new Image();

          return new Promise((resolve) => {
            img.onload = () => {
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.globalAlpha = 0.1;
              ctx.drawImage(img, 0, 0);
              const lightBase64 = canvas.toDataURL().split(',')[1];
              resolve(lightBase64);
            };
            img.src = `data:image/jpeg;base64,${base64Image}`;
          });
        } catch (error) {
          console.error('Error creating light watermark:', error);
          return base64Image;
        }
      };


      const safeGetText = (text) => {
        return String(text || 'N/A');
      };


      const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        } catch (error) {
          return dateString;
        }
      };







      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };


      const pageBorders = {
        pageBorderTop: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderRight: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderBottom: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderLeft: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        }
      };


      const createSectionHeader = (title) => {
        return new Paragraph({
          children: [
            new TextRun({
              text: title,
              bold: true,
              color: "000000",
              size: 28,
            })
          ],
          heading: HeadingLevel.HEADING_2,
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 400,
            after: 200,
          },
          shading: {
            type: "solid",
            color: "E8E8E8",
            fill: "E8E8E8",
          },
        });
      };


      const createFieldRow = (label, value) => {
        return new Table({
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: label + ':',
                          bold: true,
                          color: "34495E",
                        }),
                      ],
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  width: {
                    size: 25,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: tableBorders,
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: safeGetText(value),
                          color: "000000",
                        }),
                      ],
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  width: {
                    size: 75,
                    type: WidthType.PERCENTAGE,
                  },
                  borders: tableBorders,
                  verticalAlign: VerticalAlign.CENTER,
                }),
              ],
            }),
          ],
          width: {
            size: 100,
            type: WidthType.PERCENTAGE,
          },
          alignment: AlignmentType.CENTER,
          margins: {
            top: 100,
            bottom: 100,
            left: 100,
            right: 100,
          },
        });
      };

      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";

      const [logoBase64, watermarkBase64] = await Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]);
      const lightWatermarkBase64 = watermarkBase64 ? await createLightWatermark(watermarkBase64) : null;
      const createHeader = () => {
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: tableBorders,
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: convertInchesToTwip(0.15),
                        bottom: convertInchesToTwip(0.15),
                        left: convertInchesToTwip(0.1),
                        right: convertInchesToTwip(0.1)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                              font: "Times New Roman",
                              color: "1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                          spacing: { after: 100 }
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH INDIA-531163",
                              font: "Helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                          spacing: { after: 100 }
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "Helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: tableBorders,
                      width: { size: 80, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.CENTER,
                      margins: {
                        top: convertInchesToTwip(0.15),
                        bottom: convertInchesToTwip(0.15),
                        left: convertInchesToTwip(0.1),
                        right: convertInchesToTwip(0.1)
                      }
                    })
                  ]
                })
              ]
            })
          );
        } else {

          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color: "1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: { after: 100 }
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH INDIA-531163",
                  font: "Helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: { after: 100 }
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "Helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }


        if (lightWatermarkBase64) {
          headerElements.push(
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          );
        }

        return new Header({
          children: headerElements
        });
      };
      const createFooter = () => {
        const footerTable = new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          alignment: AlignmentType.CENTER,
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Pie Power",
                          font: "Courier New",
                          bold: true,
                          size: 18
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ],
                  borders: tableBorders,
                  width: { size: 25, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                  margins: {
                    top: convertInchesToTwip(0.25),
                    bottom: convertInchesToTwip(0.25),
                    left: convertInchesToTwip(0.25),
                    right: convertInchesToTwip(0.25)
                  }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "TPREL",
                          font: "Courier New",
                          bold: true,
                          size: 18
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ],
                  borders: tableBorders,
                  width: { size: 25, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                  margins: {
                    top: convertInchesToTwip(0.25),
                    bottom: convertInchesToTwip(0.25),
                    left: convertInchesToTwip(0.25),
                    right: convertInchesToTwip(0.25)
                  }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "TPREL",
                          font: "Courier New",
                          bold: true,
                          size: 18
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ],
                  borders: tableBorders,
                  width: { size: 25, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                  margins: {
                    top: convertInchesToTwip(0.25),
                    bottom: convertInchesToTwip(0.25),
                    left: convertInchesToTwip(0.25),
                    right: convertInchesToTwip(0.25)
                  }
                }),
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "TPREL",
                          font: "Courier New",
                          bold: true,
                          size: 18
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ],
                  borders: tableBorders,
                  width: { size: 25, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                  margins: {
                    top: convertInchesToTwip(0.25),
                    bottom: convertInchesToTwip(0.25),
                    left: convertInchesToTwip(0.25),
                    right: convertInchesToTwip(0.25)
                  }
                })
              ]
            })
          ]
        });

        const pageNumberParagraph = new Paragraph({
          children: [
            new TextRun({
              text: "Page ",
              font: "Courier New",
              size: 16
            }),
            new TextRun({
              children: [PageNumber.CURRENT],
              font: "Courier New",
              size: 16
            }),
            new TextRun({
              text: " of ",
              font: "Courier New",
              size: 16
            }),
            new TextRun({
              children: [PageNumber.TOTAL_PAGES],
              font: "Courier New",
              size: 16
            })
          ],
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 200
          }
        });

        return new Footer({
          children: [
            footerTable,
            pageNumberParagraph
          ]
        });
      };
      const sections = [];
      const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      sections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "TEST REPORT",
              bold: true,
              color: "2980B9",
              size: 72,
            })
          ],
          heading: HeadingLevel.TITLE,
          alignment: AlignmentType.CENTER,
          spacing: {
            after: 200,
          },
          shading: {
            type: "solid",
            color: "ECF0F1",
            fill: "ECF0F1",
          },
        })
      );



      sections.push(createSectionHeader('REPORT INFORMATION'));

      sections.push(createFieldRow('Equipment Name', report.equipment_name));
      sections.push(createFieldRow('Test Date', formatDate(report.test_date)));
      sections.push(createFieldRow('Category', report.category_name));
      sections.push(createFieldRow('Subcategory', report.subcategory_name));
      sections.push(createFieldRow('Project', report.sub_project_name));
      sections.push(createFieldRow('Location', report.location));
      sections.push(createFieldRow('Project ID', report.project_id));
      sections.push(createFieldRow('Equipment ID', report.equipment_id));
      sections.push(createFieldRow('Report ID', report.id || report._id || report.report_id));

      if (report.test_data && typeof report.test_data === 'object' && Object.keys(report.test_data).length > 0) {
        sections.push(createSectionHeader('TEST DATA'));

        const renderTestData = (data, level = 0) => {
          const indent = level * 20;

          Object.entries(data).forEach(([key, value]) => {
            if (value && typeof value === 'object' && !Array.isArray(value)) {

              sections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: key.toUpperCase(),
                      bold: true,
                      color: "000000",
                      size: 44,
                    })
                  ],
                  heading: HeadingLevel.HEADING_3,
                  alignment: AlignmentType.CENTER,
                  spacing: {
                    before: 200,
                    after: 100,
                  },
                  indent: {
                    left: indent,
                  },
                })
              );

              renderTestData(value, level + 1);
            } else {

              const displayKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
              let displayValue = 'N/A';

              if (Array.isArray(value)) {
                displayValue = value.join(', ');
              } else if (value !== null && value !== undefined) {
                displayValue = String(value);
              }

              sections.push(
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: displayKey + ':',
                                  bold: true,
                                  color: "34495E",
                                }),
                              ],
                              alignment: AlignmentType.CENTER,
                            }),
                          ],
                          width: {
                            size: 30,
                            type: WidthType.PERCENTAGE,
                          },
                          borders: tableBorders,
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: displayValue,
                                  color: "000000",
                                }),
                              ],
                              alignment: AlignmentType.CENTER,
                            }),
                          ],
                          width: {
                            size: 70,
                            type: WidthType.PERCENTAGE,
                          },
                          borders: tableBorders,
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                      ],
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  alignment: AlignmentType.CENTER,
                  indent: {
                    size: indent + 50,
                    type: WidthType.DXA,
                  },
                })
              );
            }
          });
        };

        renderTestData(report.test_data);
      }

      const doc = new Document({
        sections: [
          {
            properties: {
              page: {
                margin: {
                  top: convertInchesToTwip(2.0),
                  bottom: convertInchesToTwip(1.5),
                  left: convertInchesToTwip(0.5),
                  right: convertInchesToTwip(0.5)
                },
                borders: pageBorders,
                pageNumbers: {
                  start: 1,
                  formatType: NumberFormat.DECIMAL
                }
              }
            },
            children: sections,
            headers: {
              default: createHeader(),
              first: createHeader(),
              even: createHeader()
            },
            footers: {
              default: createFooter(),
              first: createFooter(),
              even: createFooter()
            }
          }
        ]
      });

      const timestamp = new Date().toISOString().slice(0, 10);
      const equipmentName = (report.equipment_name || 'Equipment').replace(/[^a-zA-Z0-9]/g, '_');
      const filename = `Test_Report_${equipmentName}_${timestamp}.docx`;

      const blob = await Packer.toBlob(doc);
      if (typeof saveAs !== 'undefined') {

        saveAs(blob, filename);
      } else {

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }

      console.log(`Word document generated successfully: ${filename}`);
      return filename;

    } catch (error) {
      console.error('Error generating Word document:', error);
      throw new Error(`Failed to generate Word document: ${error.message}`);
    }
  };


  const isImageData = (value) => {
    if (!value || typeof value !== 'string') return false;

    if (value.startsWith('data:image/')) {
      return true;
    }
    const imageUrlPattern = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    const isHttpUrl = value.startsWith('http://') || value.startsWith('https://');

    return isHttpUrl && (imageUrlPattern.test(value) || value.includes('image'));
  };


  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };


  const renderImagePreview = (imageData, altText = "Preview") => {
    if (!imageData) return null;

    return (
      <div style={{
        border: '2px dashed #dee2e6',
        borderRadius: '8px',
        padding: '10px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <img
          src={imageData}
          alt={altText}
          style={{
            maxWidth: '100%',
            maxHeight: '200px',
            objectFit: 'contain',
            borderRadius: '4px',
            border: '1px solid #dee2e6'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <div style={{ display: 'none', color: '#6c757d', padding: '20px' }}>
          <FaImage size={24} />
          <p style={{ margin: '8px 0 0 0', fontSize: '14px' }}>
            Image failed to load
          </p>
        </div>
      </div>
    );
  };

  const renderImageField = (fieldName, fullPath, value) => {
    const uploadState = imageUploadStates[fullPath] || {};
    const isImage = isImageData(value);

    return (
      <div key={fullPath} className="GET-46" style={{
        backgroundColor: '#ffffff',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        padding: '12px'
      }}>
        <label style={{
          fontWeight: '600',
          color: '#495057',
          fontSize: '14px',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaImage />
          {fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
        </label>

        {isImage && value && (
          <div style={{ marginBottom: '12px' }}>
            {renderImagePreview(value, fieldName)}
          </div>
        )}

        {!isEditing && value && (
          <div style={{
            padding: '8px 12px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
            fontSize: '12px',
            color: '#6c757d',
            wordBreak: 'break-all',
            marginBottom: isImage ? '0' : '8px'
          }}>
            URL: {value}
          </div>
        )}

        {isEditing && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

            <div>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleImageUpload(fullPath, file);
                  }
                }}
                disabled={isSaving || uploadState.uploading}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
            </div>

            {uploadState.uploading && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: '#007bff',
                fontSize: '14px'
              }}>
                <div className="GET-21" style={{ width: '16px', height: '16px' }}></div>
                Uploading image...
              </div>
            )}

            {uploadState.error && (
              <div style={{
                color: '#dc3545',
                fontSize: '12px',
                padding: '4px 8px',
                backgroundColor: '#fff5f5',
                borderRadius: '4px',
                border: '1px solid #f5c6cb'
              }}>
                Error: {uploadState.error}
              </div>
            )}

            {uploadState.uploaded && (
              <div style={{
                color: '#28a745',
                fontSize: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <FaCheck />
                Image updated successfully
              </div>
            )}

            {value && (
              <button
                type="button"
                onClick={() => handleImageRemove(fullPath)}
                disabled={isSaving}
                style={{
                  padding: '6px 12px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  width: 'fit-content'
                }}
              >
                <FaTrash />
                Remove Image
              </button>
            )}

            {value && !value.startsWith('data:image/') && (
              <div style={{
                padding: '6px 8px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                fontSize: '11px',
                color: '#6c757d',
                wordBreak: 'break-all'
              }}>
                Current URL: {value}
              </div>
            )}
          </div>
        )}

        {!isEditing && !isImage && value && (
          <span className="GET-48" style={{
            display: 'block',
            padding: '8px 12px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#495057',
            wordBreak: 'break-all'
          }}>
            {value}
          </span>
        )}

        {!value && (
          <span className="GET-48" style={{
            display: 'block',
            padding: '8px 12px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#6c757d',
            fontStyle: 'italic'
          }}>
            No image uploaded
          </span>
        )}
      </div>
    );
  };

  const updateNestedField = (fullPath, value) => {
    console.log(`Updating nested field at path: ${fullPath} with value:`, value);

    setEditableReport(prev => {
      const updated = { ...prev };
      const keys = fullPath.split('.');
      let current = updated.test_data;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]] || typeof current[keys[i]] !== 'object') {
          current[keys[i]] = {};
        }
        current = current[keys[i]];
      }

      const finalKey = keys[keys.length - 1];
      current[finalKey] = value;

      console.log(`Successfully updated ${fullPath} to:`, value);
      console.log('Updated test_data:', updated.test_data);

      return updated;
    });
  };

  const filteredReports = testReports.filter(report => {
    const matchesSearch = !searchTerm ||
      (report.equipment_name && report.equipment_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (report.project_id && String(report.project_id).toLowerCase().includes(searchTerm.toLowerCase())) ||
      (report.location && report.location.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesCategory = !filterCategory ||
      (report.category_name && report.category_name === filterCategory);

    return matchesSearch && matchesCategory;
  });

  const categories = [...new Set(testReports.map(report => report.category_name).filter(Boolean))];

  const hasValidationErrors = Object.keys(validationErrors).length > 0;
  const canSave = !isSaving && !hasValidationErrors &&
    editableReport?.equipment_name?.trim() &&
    editableReport?.test_date &&
    editableReport?.category_name?.trim();

  const renderTestDataFields = () => {
    if (!editableReport?.test_data || typeof editableReport.test_data !== 'object') {
      return <div className="GET-48">No test data available</div>;
    }

    const testData = editableReport.test_data;

    const sectionMappings = {
      form: { title: "Form Data", subtitle: "Basic Report Information" },
      testData: { title: "Test Data", subtitle: "Electrical Test Measurements" },
      hipotRun: { title: "Hi-Pot Test Results", subtitle: "High Potential Test Measurements" },
      beforeRun1: { title: "Before Run Test 1", subtitle: "Pre-Test Insulation Measurements" },
      beforeRun2: { title: "Before Run Test 2", subtitle: "Pre-Test Phase-to-Phase Measurements" },
      afterRun1: { title: "After Run Test 1", subtitle: "Post-Test Insulation Measurements" },
      afterRun2: { title: "After Run Test 2", subtitle: "Post-Test Phase-to-Phase Measurements" },
      contactResistance: { title: "Contact Resistance", subtitle: "Contact Resistance Measurements" },
      transformerData: { title: "Transformer Data", subtitle: "Transformer Test Information" },
      images: { title: "Test Images", subtitle: "Visual Documentation" },
      photos: { title: "Test Photos", subtitle: "Photographic Evidence" },
      attachments: { title: "Attachments", subtitle: "Additional Files and Images" }
    };

    const renderNestedObject = (obj, parentPath = '', level = 0) => {
      return Object.entries(obj).map(([fieldName, value]) => {
        const fullPath = parentPath ? `${parentPath}.${fieldName}` : fieldName;
        const sectionInfo = sectionMappings[fieldName];

        const isImageField = isImageData(value) ||
          fieldName.toLowerCase().includes('image') ||
          fieldName.toLowerCase().includes('photo') ||
          fieldName.toLowerCase().includes('picture') ||
          fieldName.toLowerCase().includes('attachment');

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return (
            <div key={fullPath} className="test-data-section" style={{
              gridColumn: '1 / -1',
              marginBottom: '20px',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: level === 0 ? '#f8f9fa' : '#ffffff'
            }}>
              <div style={{
                marginBottom: '15px',
                borderBottom: '1px solid #000',
                paddingBottom: '10px'
              }}>
                <h4 style={{
                  margin: '0 0 5px 0',
                  color: '#000',
                  fontSize: '18px',
                  fontWeight: 'bold'
                }}>
                  {sectionInfo ? sectionInfo.title : fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                </h4>
                {sectionInfo && (
                  <p style={{
                    margin: '0',
                    color: '#6c757d',
                    fontSize: '14px',
                    fontStyle: 'italic'
                  }}>
                    {sectionInfo.subtitle}
                  </p>
                )}
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: isImageField ? 'repeat(auto-fit, minmax(300px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px',
                marginLeft: level > 0 ? '20px' : '0'
              }}>
                {renderNestedObject(value, fullPath, level + 1)}
              </div>
            </div>
          );
        }

        if (isImageField) {
          return renderImageField(fieldName, fullPath, value);
        }
        const displayLabel = fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

        return (
          <div key={fullPath} className="GET-46" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            padding: '12px'
          }}>
            <label style={{
              fontWeight: '600',
              color: '#495057',
              fontSize: '14px',
              marginBottom: '8px',
              display: 'block'
            }}>
              {displayLabel}:
            </label>
            {isEditing ? (
              <input
                type={typeof value === 'number' ? 'number' : 'text'}
                value={value || ''}
                onChange={(e) => {
                  const newValue = e.target.value;
                  updateNestedField(fullPath, newValue);
                }}
                className="GET-47"
                placeholder={`Enter ${displayLabel}`}
                disabled={isSaving}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
            ) : (
              <span className="GET-48" style={{
                display: 'block',
                padding: '8px 12px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '4px',
                fontSize: '14px',
                color: '#495057'
              }}>
                {Array.isArray(value) ? value.join(', ') : String(value || '')}
              </span>
            )}
          </div>
        );
      });
    };

    return (
      <div style={{
        marginTop: '30px',
        padding: '20px',
        backgroundColor: '#ffffff',
        border: '1px solid #dee2e6',
        borderRadius: '8px'
      }}>
        <div style={{
          marginBottom: '25px',
          borderBottom: '3px solid #28a745',
          paddingBottom: '15px'
        }}>
          <h3 style={{
            margin: '0 0 8px 0',
            color: '#000',
            fontSize: '22px',
            fontWeight: 'bold'
          }}>
            Test Data Details
          </h3>
          <p style={{
            margin: '0',
            color: '#6c757d',
            fontSize: '16px'
          }}>
            Detailed test measurements and visual documentation
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {renderNestedObject(testData)}
        </div>
      </div>
    );
  };

  const renderImagesSection = () => {
    if (!editableReport?.test_data) return null;
    const imageFields = [
      { key: 'nameplate', label: 'Nameplate Image', required: false },
      { key: 'beforeTest', label: 'Before Test Image', required: false },
      { key: 'duringTest', label: 'During Test Image', required: false },
      { key: 'afterTest', label: 'After Test Image', required: false },
      { key: 'equipmentOverall', label: 'Equipment Overall View', required: false },
      { key: 'testSetup', label: 'Test Setup Image', required: false }
    ];

    if (editableReport.category_name === 'Transformers 1') {
      imageFields.push(
        { key: 'windingDiagram', label: 'Winding Diagram', required: false },
        { key: 'connectionDiagram', label: 'Connection Diagram', required: false }
      );
    } else if (editableReport.category_name === 'Transformers 2') {
      imageFields.push(
        { key: 'vectorGroup', label: 'Vector Group Diagram', required: false },
        { key: 'tapChanger', label: 'Tap Changer Image', required: false }
      );
    }

    const images = editableReport.test_data.images || {};

    return (
      <div style={{
        marginTop: '30px',
        padding: '20px',
        backgroundColor: '#ffffff',
        border: '1px solid #dee2e6',
        borderRadius: '8px'
      }}>
        <div style={{
          marginBottom: '25px',
          borderBottom: '3px solid #007bff',
          paddingBottom: '15px'
        }}>
          <h3 style={{
            margin: '0 0 8px 0',
            color: '#000',
            fontSize: '22px',
            fontWeight: 'bold'
          }}>
            Images Section
          </h3>
          <p style={{
            margin: '0',
            color: '#6c757d',
            fontSize: '16px'
          }}>
            Upload and manage test report images
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px'
        }}>
          {imageFields.map(({ key, label, required }) => {
            const imageData = images[key];
            const hasImage = imageData && (imageData.url || imageData);
            const imageUrl = typeof imageData === 'string' ? imageData : imageData?.url;

            return (
              <div key={key} style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '15px',
                backgroundColor: '#f8f9fa'
              }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  color: '#495057',
                  marginBottom: '10px',
                  fontSize: '14px'
                }}>
                  {label} {required && <span style={{ color: 'red' }}>*</span>}
                </label>
                {hasImage && (
                  <div style={{ marginBottom: '15px' }}>
                    <img
                      src={imageUrl}
                      alt={label}
                      style={{
                        width: '100%',
                        maxHeight: '200px',
                        objectFit: 'cover',
                        borderRadius: '6px',
                        border: '1px solid #dee2e6'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div style={{
                      display: 'none',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      color: '#6c757d'
                    }}>
                      <FaExclamationTriangle style={{ marginBottom: '10px' }} />
                      <br />
                      Image failed to load
                    </div>

                    {imageData?.filename && (
                      <p style={{
                        fontSize: '12px',
                        color: '#6c757d',
                        margin: '5px 0 0 0',
                        wordBreak: 'break-all'
                      }}>
                        {imageData.filename}
                      </p>
                    )}
                  </div>
                )}

                {isEditing ? (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          handleImageUpload(key, file);
                        }
                      }}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '14px',
                        marginBottom: '10px'
                      }}
                      disabled={isSaving}
                    />

                    <div style={{ display: 'flex', gap: '10px' }}>
                      {hasImage && (
                        <button
                          type="button"
                          onClick={() => handleImageRemove(key)}
                          disabled={isSaving}
                          style={{
                            flex: 1,
                            padding: '6px 12px',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px'
                          }}
                        >
                          <FaTimes /> Remove
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  !hasImage && (
                    <div style={{
                      padding: '30px',
                      textAlign: 'center',
                      backgroundColor: '#f8f9fa',
                      border: '2px dashed #dee2e6',
                      borderRadius: '6px',
                      color: '#6c757d'
                    }}>
                      <FaExclamationTriangle style={{ marginBottom: '10px', fontSize: '24px' }} />
                      <br />
                      No image available
                    </div>
                  )
                )}

                {required && validationErrors[key] && (
                  <div style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '5px'
                  }}>
                    {validationErrors[key]}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };





  return (
    <div className="GET-01">
      <div className="GET-02">
        <div className="GET-03">

          <div className="GET-07">

            <button
              className="GET-08 GET-10"
              onClick={fetchTestReports}
              disabled={isLoading}
              title="Refresh reports list"
            >
              <FaSyncAlt className={isLoading ? 'GET-11' : ''} />
              {isLoading ? "Loading..." : "Refresh"}
            </button>
            <label
              className="GET-08 GET-10"
              style={{
                cursor: isUploadingFiles ? 'not-allowed' : 'pointer',
                backgroundColor: isUploadingFiles ? '#6c757d' : '#074f15ff',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: '500',
                opacity: isUploadingFiles ? 0.6 : 1
              }}
            >
              <FaUpload /> {isUploadingFiles ? 'Uploading...' : 'Upload Files'}
              <input
                type="file"
                multiple
                onChange={handleFileUpload}
                disabled={isUploadingFiles}
                style={{ display: 'none' }}
                accept=".doc,.docx,.pdf,.xls,.xlsx,.zip,.rar,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/x-rar-compressed"
              />
            </label>
            <button onClick={onCancel} className="GET-08 GET-12">
              <FaTimes />
            </button>
          </div>


          <div style={{
            display: 'flex',
            gap: '10px',
            padding: '10px 20px',
            backgroundColor: '#f8f9fa',
            borderBottom: '2px solid #dee2e6'
          }}>
            <button
              onClick={() => setActiveTab('reports')}
              style={{
                padding: '10px 20px',
                border: 'none',
                backgroundColor: activeTab === 'reports' ? '#28a745' : 'transparent',
                color: activeTab === 'reports' ? 'white' : '#495057',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: activeTab === 'reports' ? '600' : '400',
                transition: 'all 0.3s ease'
              }}
            >
              📋 Test Reports ({testReports.length})
            </button>


            <button
              onClick={() => {
                setShowUploadedFilesScreen(true);
                fetchUploadedFiles();
              }}
              style={{
                padding: '10px 20px',
                border: 'none',
                backgroundColor: '#28a745',
                color: 'white',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}
            >
              📁 Uploaded Files
            </button>

          </div>
        </div>


        {showUploadedFilesScreen && (
          <div className="GET-38" style={{ zIndex: 1001 }}>
            <div
              className="GET-39"
              style={{
                maxWidth: '95%',
                width: '95%',
                maxHeight: '90vh',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              {/* Header */}
              <div className="GET-40">
                <h3>📁 Uploaded Files</h3>
                <div className="GET-41">
                  <button
                    onClick={() => setShowUploadedFilesScreen(false)}
                    className="GET-08 GET-09"
                  >
                    <FaTimes /> Close
                  </button>
                  <button
                    onClick={fetchUploadedFiles}
                    className="GET-08 GET-10"
                    disabled={isLoading}
                  >
                    <FaSyncAlt className={isLoading ? 'GET-11' : ''} />
                    {isLoading ? 'Refreshing...' : 'Refresh'}
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="GET-43">
                {isLoading ? (
                  <div className="GET-20">
                    <div className="GET-21"></div>
                    <p>Loading uploaded files...</p>
                  </div>
                ) : uploadedFiles.length === 0 ? (
                  <div className="GET-23">
                    <div className="GET-24">📁</div>
                    <h3>No Files Uploaded</h3>
                    <p>
                      Upload Word documents, PDFs, or Excel files using the "Upload Files" button.
                      <br />
                      Your uploaded files will appear here.
                    </p>
                  </div>
                ) : (
                  <div className="GET-22">
                    {uploadedFiles.map((file) => {
                      const cleanFilename = getCleanFilename(file.upload_file);

                      return (
                        <div key={file.upload_id} className="GET-25">
                          <div className="GET-26">
                            <div style={{
                              flex: 1,
                              minWidth: 0,
                              overflow: 'hidden'
                            }}>
                              <h3 className="GET-27" title={cleanFilename} style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                marginBottom: '8px',
                                display: 'flex',
                                alignItems: 'center'
                              }}>
                                {getFileIcon(file.upload_file)}
                                {cleanFilename}
                              </h3>
                            </div>
                            <span className="GET-28" style={{
                              flexShrink: 0,
                              whiteSpace: 'nowrap'
                            }}>
                              {formatDate(file.uploaded_at)}
                            </span>
                          </div>

                          <div className="GET-29" style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '10px',
                            padding: '10px 0'
                          }}>

                          </div>

                          <div className="GET-33">
                            <button
                              className="GET-08 GET-34 GET-36"
                              onClick={() => handleFileDownload(file)}
                              title="Download this file"
                            >
                              <FaDownload />
                            </button>
                            <button
                              className="GET-08 GET-34 GET-37"
                              onClick={() => {
                                if (window.confirm(`Are you sure you want to delete "${cleanFilename}"?`)) {
                                  handleFileDelete(file.upload_id);
                                }
                              }}
                              title="Delete this file"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="GET-03">
          <div className="GET-07">
            <button
              onClick={handleHome}
              disabled={currentLevel === 'location'}
              className="GET-08 GET-10"
              style={{
                background: currentLevel === 'location' ? '#e5e7eb' : '#6b7280',
                cursor: currentLevel === 'location' ? 'not-allowed' : 'pointer',
                opacity: currentLevel === 'location' ? 0.6 : 1
              }}
              title="Go to home"
            >
              <FaHome /> Home
            </button>
            <button
              onClick={handleBack}
              disabled={breadcrumbs.length <= 1}
              className="GET-08 GET-10"
              style={{
                background: breadcrumbs.length <= 1 ? '#e5e7eb' : '#6b7280',
                cursor: breadcrumbs.length <= 1 ? 'not-allowed' : 'pointer',
                opacity: breadcrumbs.length <= 1 ? 0.6 : 1
              }}
              title="Go back"
            >
              <FaArrowLeft /> Back
            </button>

          </div>
        </div>

        {/* Breadcrumbs */}
        <div style={{
          padding: '15px 25px',
          background: '#f8fafc',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              <button
                onClick={() => handleBreadcrumbClick(index)}
                style={{
                  background: index === breadcrumbs.length - 1 ? '#4f46e5' : 'transparent',
                  color: index === breadcrumbs.length - 1 ? 'white' : '#6b7280',
                  border: 'none',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: index === breadcrumbs.length - 1 ? '600' : '500'
                }}
              >
                {crumb.label}
              </button>
              {index < breadcrumbs.length - 1 && (
                <span style={{ color: '#6b7280' }}>›</span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Content Area */}
        <div className="GET-13">
          {isLoading ? (
            <div className="GET-20">
              <div className="GET-21"></div>
              <p>Loading test reports...</p>
            </div>
          ) : errorMessage ? (
            <div style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#991b1b',
              padding: '16px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              {errorMessage}
            </div>
          ) : currentData && currentData.length > 0 ? (
            <div className="GET-22">
              {currentData.map((item, index) => (
                <div
                  key={index}
                  className="GET-25"
                  onClick={() => item.type !== 'report' && handleCardClick(item)}
                  style={{
                    cursor: item.type !== 'report' ? 'pointer' : 'default'
                  }}
                >
                  <div className="GET-26">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
                      {item.type === 'report' ? (
                        <FaFileWord style={{ fontSize: '32px', color: '#2563eb' }} />
                      ) : (
                        <FaFolder style={{ fontSize: '32px', color: '#f59e0b' }} />
                      )}
                      <div style={{ flex: 1 }}>
                        <h3 className="GET-27">{item.name}</h3>
                        {item.test_date && (
                          <span className="GET-28">{formatDate(item.test_date)}</span>
                        )}
                        {item.reportsCount !== undefined && (
                          <p style={{
                            margin: '4px 0 0 0',
                            fontSize: '13px',
                            color: '#6b7280'
                          }}>
                            {item.reportsCount} {item.reportsCount === 1 ? 'report' : 'reports'}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {item.type === 'report' && (
                    <div className="GET-33">
                      <button
                        className="GET-08 GET-34 GET-35"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreview(item.fullReport);
                        }}
                        title="View report details"
                      >
                        <FaEye /> View
                      </button>

                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="GET-23">
              <div className="GET-24">📋</div>
              <h3>No Items Found</h3>
              <p>No data available at this level</p>
            </div>
          )}
        </div>



        {previewData && editableReport && !showReportScreen && (
          <div className="GET-38">
            <div className="GET-39">
              <div className="GET-40">
                <h3>Report Details - {previewData.equipment_name}</h3>
                <div className="GET-41">
                  <button
                    onClick={handleCancel}
                    className="GET-08 GET-09"
                    disabled={isSaving}
                  >
                    <FaTimes /> {isEditing ? 'Cancel Edit' : 'Cancel'}
                  </button>
                  {!isEditing ? (
                    <button
                      onClick={handleEdit}
                      className="GET-08 GET-42"
                    >
                      <FaEdit /> Update
                    </button>
                  ) : (
                    <button
                      onClick={handleSaveChanges}
                      className="GET-08 GET-36"
                      disabled={!canSave}
                      style={{
                        backgroundColor: !canSave ? '#6c757d' : '#28a745',
                        cursor: !canSave ? 'not-allowed' : 'pointer',
                        opacity: !canSave ? 0.6 : 1
                      }}
                      title={
                        isSaving ? 'Saving changes...' :
                          !canSave ? 'Please fill required fields (Equipment Name, Test Date, Category)' :
                            'Save changes to backend'
                      }
                    >
                      <FaSave /> {isSaving ? 'Saving...' : 'Save Changes'}
                    </button>
                  )}

                </div>
              </div>

              <div className="GET-43">
                <div className="GET-44">
                  <h4>Report Information</h4>

                  {/* Display hierarchical path for the report */}
                  <div style={{ margin: '6px 0 12px', color: '#6c757d' }}>
                    <strong>Path:</strong>{' '}
                    {[
                      (isEditing ? editableReport?.sub_project_name : previewData?.sub_project_name),
                      (isEditing ? editableReport?.category_name : previewData?.category_name),
                      (isEditing ? editableReport?.subcategory_name : previewData?.subcategory_name),
                      (isEditing ? editableReport?.equipment_name : previewData?.equipment_name)
                    ].filter(Boolean).join(' / ') || 'N/A'}
                  </div>

                  {isSaving && (
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#e7f3ff',
                      border: '1px solid #b3d9ff',
                      borderRadius: '6px',
                      marginBottom: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: '500'
                    }}>
                      <div className="GET-21" style={{ marginRight: '12px' }}></div>
                      <span> Saving changes to backend... Please wait.</span>
                    </div>
                  )}

                  <div className="GET-45">
                    <div className="GET-46">
                      <label>Equipment Name: <span style={{ color: 'red' }}>*</span></label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.equipment_name || ''}
                          onChange={(e) => handleFieldChange('equipment_name', e.target.value)}
                          className="GET-47"
                          required
                          placeholder="Enter equipment name"
                          disabled={isSaving}
                          style={{
                            borderColor: validationErrors.equipment_name ? '#dc3545' : '',
                            backgroundColor: validationErrors.equipment_name ? '#fff5f5' : ''
                          }}
                        />
                      ) : (
                        <span className="GET-48">{previewData.equipment_name || 'N/A'}</span>
                      )}
                      {validationErrors.equipment_name && (
                        <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                          {validationErrors.equipment_name}
                        </div>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Test Date: <span style={{ color: 'red' }}>*</span></label>
                      {isEditing ? (
                        <input
                          type="date"
                          value={editableReport.test_date || ''}
                          onChange={(e) => handleFieldChange('test_date', e.target.value)}
                          className="GET-47"
                          required
                          disabled={isSaving}
                          style={{
                            borderColor: validationErrors.test_date ? '#dc3545' : '',
                            backgroundColor: validationErrors.test_date ? '#fff5f5' : ''
                          }}
                        />
                      ) : (
                        <span className="GET-48">{formatDate(previewData.test_date)}</span>
                      )}
                      {validationErrors.test_date && (
                        <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                          {validationErrors.test_date}
                        </div>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Category: <span style={{ color: 'red' }}>*</span></label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.category_name || ''}
                          onChange={(e) => handleFieldChange('category_name', e.target.value)}
                          className="GET-47"
                          required
                          placeholder="Enter category"
                          disabled={isSaving}
                          style={{
                            borderColor: validationErrors.category_name ? '#dc3545' : '',
                            backgroundColor: validationErrors.category_name ? '#fff5f5' : ''
                          }}
                        />
                      ) : (
                        <span className="GET-48">{previewData.category_name || 'N/A'}</span>
                      )}
                      {validationErrors.category_name && (
                        <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                          {validationErrors.category_name}
                        </div>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Subcategory:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.subcategory_name || ''}
                          onChange={(e) => handleFieldChange('subcategory_name', e.target.value)}
                          className="GET-47"
                          placeholder="Enter subcategory"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.subcategory_name || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Project:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.sub_project_name || ''}
                          onChange={(e) => handleFieldChange('sub_project_name', e.target.value)}
                          className="GET-47"
                          placeholder="Enter project name"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.sub_project_name || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Location:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.location || ''}
                          onChange={(e) => handleFieldChange('location', e.target.value)}
                          className="GET-47"
                          placeholder="Enter location"
                          disabled={isSaving}
                          style={{
                            borderColor: validationErrors.location ? '#dc3545' : '',
                            backgroundColor: validationErrors.location ? '#fff5f5' : ''
                          }}
                        />
                      ) : (
                        <span className="GET-48">{previewData.location || 'N/A'}</span>
                      )}
                      {validationErrors.location && (
                        <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                          {validationErrors.location}
                        </div>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Project ID:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.project_id || ''}
                          onChange={(e) => handleFieldChange('project_id', e.target.value)}
                          className="GET-47"
                          placeholder="Enter project ID"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.project_id || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Equipment ID:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.equipment_id || ''}
                          onChange={(e) => handleFieldChange('equipment_id', e.target.value)}
                          className="GET-47"
                          placeholder="Enter equipment ID"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.equipment_id || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Category ID:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.category_id || ''}
                          onChange={(e) => handleFieldChange('category_id', e.target.value)}
                          className="GET-47"
                          placeholder="Enter category ID"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.category_id || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Subcategory ID:</label>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editableReport.subcategory_id || ''}
                          onChange={(e) => handleFieldChange('subcategory_id', e.target.value)}
                          className="GET-47"
                          placeholder="Enter subcategory ID"
                          disabled={isSaving}
                        />
                      ) : (
                        <span className="GET-48">{previewData.subcategory_id || 'N/A'}</span>
                      )}
                    </div>

                    <div className="GET-46">
                      <label>Report ID:</label>
                      <span className="GET-48" style={{
                        fontFamily: 'monospace',
                        backgroundColor: '#f8f9fa',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        border: '1px solid #dee2e6',
                        fontSize: '13px'
                      }}>
                        {previewData.id || previewData._id || previewData.report_id || 'No ID Found'}
                      </span>
                    </div>
                  </div>

                  {(previewData.category_name === 'Transformers 1' || previewData.category_name === 'Transformers 2') && renderImagesSection()}

                  {renderTestDataFields()}
                </div>
              </div>
            </div>
          </div>
        )}




        {showReportScreen && currentReportType && (
          <div className="GET-38" style={{ zIndex: 1001 }}>
            <div
              className="GET-39"
              style={{
                maxWidth: '95%',
                width: '95%',
                maxHeight: '90vh',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              {currentReportType === 'BUSBAR' && (
                <BusbarUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  equipmentType={previewData.subcategory_name}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'CABLES' && (
                <CablesUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'TRANSFORMERS' && (
                <TransformerOneUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'CB' && (
                <CBUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  instrument={previewData.equipment_name}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'CT' && (
                <FormUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  instrument={previewData.equipment_name}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'RELAYS' && (
                <RelaysOneUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  instrument={previewData.equipment_name}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'RELAYSCT' && (
                <RelaysCTOneUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  instrument={previewData.equipment_name}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
              {currentReportType === 'VT' && (
                <VTHomeUpdate
                  block={previewData.sub_project_name}
                  plant={previewData.plant}
                  instrument={previewData.equipment_name}
                  project={{
                    ...project,
                    project_id: project?.project_id || project?.id,
                    id: project?.project_id || project?.id
                  }}
                  reportToUpdate={previewData}
                  goBack={() => {
                    setShowReportScreen(false);
                    setCurrentReportType(null);
                    setPreviewData(null);
                    fetchTestReports();
                  }}
                  isUpdateMode={true}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );

};
export default ToGetTestReportsView;
















